import { mastraClient } from '@/lib/mastra-client';
import type { WorkflowsResponse, WorkflowDefinition, WorkflowRunDetail, WorkflowRunsResponse } from '../types/workflow';

export async function fetchWorkflows(): Promise<WorkflowsResponse> {
  const res = await mastraClient.listWorkflows();
  return res as unknown as WorkflowsResponse;
}

export async function fetchWorkflow(id: string): Promise<WorkflowDefinition> {
  const res = await mastraClient.getWorkflow(id).details();
  return res as unknown as WorkflowDefinition;
}

export async function fetchWorkflowRuns(workflowId: string, limit = 20): Promise<WorkflowRunsResponse> {
  const res = await mastraClient.getWorkflow(workflowId).runs({ limit } as unknown as Parameters<ReturnType<typeof mastraClient.getWorkflow>['runs']>[0]);
  return res as unknown as WorkflowRunsResponse;
}

export async function fetchWorkflowRun(workflowId: string, runId: string): Promise<WorkflowRunDetail> {
  const res = await mastraClient.getWorkflow(workflowId).runById(runId);
  return res as unknown as WorkflowRunDetail;
}

export async function executeWorkflow(workflowId: string, inputData?: Record<string, unknown>): Promise<{ runId: string }> {
  const run = await mastraClient.getWorkflow(workflowId).createRun();
  await run.startAsync({ inputData: (inputData ?? {}) as Record<string, unknown> });
  return { runId: run.runId };
}
